export const properties = [
  {
    id: 1,
    name: "Cozy 1-Bedroom Apartment in Midtown",
    address: "123 Main St",
    city: "New York",
    state: "NY",
    zip: "10001",
    price: 2000,
    bedrooms: 1,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-1.jpg",
  },
  {
    id: 2,
    name: "Sunny 2-Bedroom Apartment in SoMa",
    address: "456 Elm St",
    city: "San Francisco",
    state: "CA",
    zip: "94105",
    price: 3000,
    bedrooms: 2,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-2.jpg",
  },
  {
    id: 3,
    name: "Spacious 3-Bedroom House in Hollywood Hills",
    address: "789 Oak St",
    city: "Los Angeles",
    state: "CA",
    zip: "90001",
    price: 4000,
    bedrooms: 3,
    bathrooms: 2,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-3.jpg",
  },
  {
    id: 4,
    name: "Charming 2-Bedroom Apartment in Downtown",
    address: "1012 Pine St",
    city: "Chicago",
    state: "IL",
    zip: "60601",
    price: 2500,
    bedrooms: 2,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-4.jpg",
  },
  {
    id: 5,
    name: "Luxurious 3-Bedroom House in Beacon Hill",
    address: "1314 Maple St",
    city: "Boston",
    state: "MA",
    zip: "02108",
    price: 3500,
    bedrooms: 3,
    bathrooms: 2,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-5.jpg",
  },
  {
    id: 6,
    name: "Stylish 1-Bedroom Apartment in West Loop",
    address: "567 Jackson Blvd",
    city: "Chicago",
    state: "IL",
    zip: "60661",
    price: 2200,
    bedrooms: 1,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-6.jpg",
  },
  {
    id: 7,
    name: "Modern 2-Bedroom Condo in South Beach",
    address: "789 Ocean Dr",
    city: "Miami",
    state: "FL",
    zip: "33139",
    price: 4000,
    bedrooms: 2,
    bathrooms: 2,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-7.jpg",
  },
  {
    id: 8,
    name: "Charming 3-Bedroom Cottage in Napa Valley",
    address: "123 Vineyard Ln",
    city: "Napa",
    state: "CA",
    zip: "94558",
    price: 5000,
    bedrooms: 3,
    bathrooms: 2,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-8.jpg",
  },
  {
    id: 9,
    name: "Cozy 2-Bedroom Apartment in Capitol Hill",
    address: "456 8th St",
    city: "Washington",
    state: "DC",
    zip: "20002",
    price: 2800,
    bedrooms: 2,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-9.jpg",
  },
  {
    id: 10,
    name: "Spacious 4-Bedroom House in Pacific Palisades",
    address: "789 Sunset Blvd",
    city: "Los Angeles",
    state: "CA",
    zip: "90272",
    price: 6000,
    bedrooms: 4,
    bathrooms: 3,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-10.jpg",
  },
  {
    id: 11,
    name: "Stunning 2-Bedroom Loft in SoHo",
    address: "123 Prince St",
    city: "New York",
    state: "NY",
    zip: "10012",
    price: 3800,
    bedrooms: 2,
    bathrooms: 2,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-11.jpg",
  },
  {
    id: 12,
    name: "Luxurious 3-Bedroom Condo in Beverly Hills",
    address: "456 Rodeo Dr",
    city: "Beverly Hills",
    state: "CA",
    zip: "90210",
    price: 5500,
    bedrooms: 3,
    bathrooms: 3,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-12.jpg",
  },
  {
    id: 13,
    name: "Chic 1-Bedroom Apartment in River North",
    address: "789 North Orleans St",
    city: "Chicago",
    state: "IL",
    zip: "60654",
    price: 1900,
    bedrooms: 1,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-13.jpg",
  },
  {
    id: 14,
    name: "Modern 2-Bedroom House in Silver Lake",
    address: "1234 Sunset Blvd",
    city: "Los Angeles",
    state: "CA",
    zip: "90026",
    price: 5000,
    bedrooms: 2,
    bathrooms: 2,
    type: "House",
    image: "https://generatorfun.com/code/uploads/Random-House-image-14.jpg",
  },
  {
    id: 15,
    name: "Cozy 1-Bedroom Apartment in Adams Morgan",
    address: "567 Columbia Rd",
    city: "Washington",
    state: "DC",
    zip: "20009",
    price: 1800,
    bedrooms: 1,
    bathrooms: 1,
    type: "Apartment",
    image: "https://generatorfun.com/code/uploads/Random-House-image-15.jpg",
  },
];



